import { uploadToCloudinary } from "./cloudinary";
import type { CloudinaryUploadResult } from "../types/submission";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

interface UploadWithRetryOptions {
  maxAttempts?: number;
}

export async function uploadWithRetry(
  file: string,
  { maxAttempts = 3 }: UploadWithRetryOptions = {}
): Promise<CloudinaryUploadResult> {
  let lastError: Error = new Error("Upload failed");

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const data = await uploadToCloudinary(file);
      if (data?.secure_url) return data as CloudinaryUploadResult;
      lastError = new Error("No secure_url in response");
    } catch (err) {
      lastError = err instanceof Error ? err : new Error("Upload failed");
    }

    if (attempt < maxAttempts) {
      await delay(1000 * attempt);
    }
  }

  throw lastError;
}
